/**
 * AiTruncationNotice — aviso PADRÃO de que um retorno da IA foi CORTADO (truncado).
 *
 * Regra do produto: toda tela que mostra saída de IA sinaliza SÓ quando cortou —
 * quando completo, não renderiza nada (sem poluir com selo verde em toda tela).
 *
 * Uso: <AiTruncationNotice complete={data?.aiComplete} onRetry={() => mutate()} />
 * `complete` vem do backend (aiComplete). undefined/true = completo → null.
 */
import { C } from '@/theme/palette';

export function AiTruncationNotice({ complete, onRetry, label }) {
  if (complete !== false) return null;   // completo (ou desconhecido) → nada
  const danger = C.hotLight || C.hot || C.bad || '#FFA29E';
  return (
    <div
      role="alert"
      className="flex items-center gap-2"
      style={{
        margin: '8px 0', padding: '9px 13px', borderRadius: 8, fontSize: 12.5,
        fontWeight: 600, color: danger, backgroundColor: `${danger}14`,
        border: `1px solid ${danger}55`, lineHeight: 1.45, flexWrap: 'wrap',
      }}
    >
      <span aria-hidden="true">⚠</span>
      <span style={{ flex: 1 }}>
        {label || 'Este retorno da IA foi CORTADO (truncado por limite de tokens) — o conteúdo pode estar incompleto.'}
      </span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            cursor: 'pointer', background: 'none', border: `1px solid ${danger}88`,
            color: danger, borderRadius: 6, padding: '3px 10px', fontSize: 12, fontWeight: 600,
          }}
        >
          Gerar novamente
        </button>
      )}
    </div>
  );
}
